import { Avatar, MenuItem, Select, TextField } from "@mui/material";
import { LockIcon } from "components/Statics";
import React from "react";
import styles from "./input.module.scss";
import cx from "classnames";
import { createEvent } from "helpers/utils/utilities";

const CompositeInput = ({
  placeholder,
  value,
  name,
  onChange,
  t = (d) => d,
  required,
  hideAsterisk,
  noWrapDecsription,
  description,
  options,
  optionName,
  optionValue,
  classes,
  title,
  locked,
  top,
  height,
  width,
  error,
}) => {
  const handleMenuItemClick = (e) => {
    let val = e.target.id;
    onChange(createEvent(optionName, val == optionValue ? undefined : val));
  };

  return (
    <div
      data-testid="input"
      style={{ marginTop: top }}
      className={cx(styles.inputContainer, classes)}
    >
      {!!title && (
        <p className={`${styles.title} flex items-center} text-nowrap`}>
          {typeof title === "string" ? t(title) : title}
          {!!required && !hideAsterisk && <span>*</span>}
          {locked && <LockIcon />}
        </p>
      )}
      {!!description && (
        <p
          className={`${styles.description} ${
            noWrapDecsription ? "text-nowrap" : ""
          }`}
          dangerouslySetInnerHTML={{ __html: t(description) }}
        />
      )}
      <TextField
        placeholder={t(placeholder)}
        value={value}
        name={name}
        onChange={onChange}
        sx={{
          height: !!height && height,
          width: !!width && width,
          "& .MuiSelect-select": {
            paddingLeft: "5px",
            paddingY: "9px",
            maxHeight: "110px",
            overflowY: "auto!important",
          },
          "& .MuiInputBase-root.MuiOutlinedInput-root": {
            height: "100% !important",
            minHeight: "40px",
          },
          "& .MuiInputBase-input": {
            padding: "2px 10px !important",
          },
        }}
        className={cx(styles.select, { [styles.error]: !!error }, "w-full")}
        InputProps={{
          startAdornment: (
            <Select
              options={options}
              sx={{
                "& .MuiSelect-select.MuiInputBase-input": {
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "0px !important",
                  gap: "2px",
                  fontSize: "14px",
                  fontWeight: "500",
                },
              }}
              name={optionName}
              className="minw-100 c-title pr-2 border-r"
              value={optionValue}
            >
              {!!options &&
                options?.map(({ key, value, icon }) => (
                  <MenuItem
                    onClick={handleMenuItemClick}
                    className="px-2 fs-14 fw-500"
                    key={key}
                    value={key}
                    id={key}
                  >
                    {icon && (
                      <Avatar
                        src={icon}
                        alt={value}
                        className="h-20 object-cover w-25 mr-1"
                      />
                    )}
                    {t(value, "common")}
                  </MenuItem>
                ))}
            </Select>
          ),
        }}
      />
      {error && <p className={styles.error}>{t(error, "common")}</p>}
    </div>
  );
};

export default CompositeInput;
